import { SLOW_CONTROL_STEP_COUNT } from "./reverb-steps.js";

export const SLIDER_MARKER_GROUP = 4;
export const ACTIVE_MARKER_EPSILON = 0.01;

export function sliderFillPct({ min, max, midValue, value }) {
  const numMin = Number(min);
  const numMax = Number(max);
  const numMid = Number(midValue);
  const numValue = Number(value);

  if (!Number.isFinite(numMin) || !Number.isFinite(numMax) || numMax <= numMin) {
    return 0;
  }

  const hasCustomMid =
    Number.isFinite(numMid) && numMid > numMin && numMid < numMax;
  const ratio = hasCustomMid
    ? numValue <= numMid
      ? ((numValue - numMin) / (numMid - numMin)) * 0.5
      : 0.5 + ((numValue - numMid) / (numMax - numMid)) * 0.5
    : (numValue - numMin) / (numMax - numMin);
  return Math.min(100, Math.max(0, ratio * 100));
}

export function stepIndexPct(index, stepCount) {
  if (stepCount <= 1) return 0;
  return (index / (stepCount - 1)) * 100;
}

export function buildSliderMarkerPcts(
  stepCount,
  groupSize = SLIDER_MARKER_GROUP,
) {
  if (stepCount <= 0) return [];

  const markerPcts = [];
  for (let index = 0; index < stepCount; index += groupSize) {
    markerPcts.push(stepIndexPct(index, stepCount));
  }
  return markerPcts;
}

export const CONTROL_SLIDER_MARKER_PCTS = buildSliderMarkerPcts(
  SLOW_CONTROL_STEP_COUNT,
);

export function isDistinctMarker(markerPct, activePct) {
  return Math.abs(markerPct - activePct) > ACTIVE_MARKER_EPSILON;
}

export function pointerPctWithinTrack(clientX, trackEl) {
  if (!trackEl) return 0;

  const rect = trackEl.getBoundingClientRect();
  if (rect.width <= 0) return 0;

  const styles = getComputedStyle(trackEl);
  const thumbSize =
    parseFloat(styles.getPropertyValue("--slider-thumb-size")) || 20;
  const innerWidth = rect.width - thumbSize;

  if (innerWidth <= 0) return 0;

  const x = clientX - rect.left - thumbSize / 2;
  return Math.min(100, Math.max(0, (x / innerWidth) * 100));
}
